<template>
  <div>
    <div>
      <el-button
        style="margin-bottom: 10px"
        type="primary"
        icon="el-icon-plus"
        @click="openEditForceUpdateConfigDialog(true)"
        >新增配置项</el-button
      >
    </div>

    <el-table
      :data="forceUpdateConfigList"
      border
      size="small"
      style="width: 1101px"
    >
      <el-table-column
        prop="channelName"
        label="渠道"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="clientAttrType"
        label="客户端特征类型"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="clientAttrValue"
        label="客户端特征值"
        show-overflow-tooltip
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="version"
        label="最低可用版本"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="url"
        label="强更新地址"
        align="center"
        width="230"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip
        align="center"
        width="200"
      >
      </el-table-column>

      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="deleteForceUpdateConfig(scope.row)"
            >删除</el-button
          >
          <el-button
            type="primary"
            round
            size="mini"
            @click="openEditForceUpdateConfigDialog(false, scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
    
    <script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
  data() {
    return {
      forceUpdateConfigList: [],
    };
  },

  created() {
    this.loadForceUpdateConfigList();
  },

  methods: {
    async loadForceUpdateConfigList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryAppForceUpdateConfigList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.entries || [];

      // 排序（按id倒序排列）
      listInResponse.sort((x, y) => {
        return y.id - x.id;
      });

      this.forceUpdateConfigList = listInResponse;
    },

    /**
     * 删除
     * @param {*} entry
     */
    async deleteForceUpdateConfig(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除该配置项？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/deleteAppForceUpdateConfig`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.forceUpdateConfigList.length; i++) {
          if (this.forceUpdateConfigList[i].id == entry.id) {
            this.forceUpdateConfigList.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    /**
     * 打开“编辑热更新配置”对话框
     */
    openEditForceUpdateConfigDialog(isCreate, oldData) {
      let dataForDialog = {
        isCreate: isCreate,
        form: {
          clientAttrType: "ip",
        },
      };

      if (oldData) {
        dataForDialog.id = oldData.id;
        dataForDialog.form = {
          clientAttrType: oldData.clientAttrType,
          clientAttrValue: oldData.clientAttrValue,
          version: oldData.version,
          remark: oldData.remark,
          url: oldData.url,
          channelId: oldData.channelId,
        };
      }

      dialogutil.open("EditForceUpdateConfigDialog", {
        closedCallback: () => {
          this.loadForceUpdateConfigList();
        },
        data: dataForDialog,
      });
    },
  },
};
</script>